const offsetForHiddenModal = -1600;
const KEY_CODE_ESCAPE = 27;
const offsetToClose = -75;
const offsetLimit = 200;
export { offsetForHiddenModal, KEY_CODE_ESCAPE, offsetToClose, offsetLimit };
